// libs
import styled from 'styled-components'
// components
// themes
import { colors } from 'themes'
// views
import { Header as HeaderOrigin } from 'components/Modals/PlanItems/styles'
import { Scrollbar as ActivitiesScrollbar } from '../PlanItems/components/ActivitiesList/components/ActivitiesContent'
// utils
import { ellipsis } from 'polished'

const ReviewDate = styled.div<{ $isUpdate: boolean }>`
  font-weight: normal;
  font-size: 18px;
  max-width: 250px;
  margin-left: ${({ $isUpdate }) => ($isUpdate ? '0' : 'auto')};
`

const UpdateIndicator = styled.div`
  font-weight: bold;
  font-size: 18px;
  width: 168px;
  margin-left: auto;
`

const RightSidebar = styled.div`
  border-left: 2px solid ${colors.gray230};
  box-shadow: 0 4px 32px 0 rgba(232, 232, 235, 0.6);
  height: 100%;
  width: 603px;
`

const EntityDescription = styled.div`
  font-weight: normal;
  padding-right: 16px;
  ${ellipsis('60%')};
`

const IconWrapper = styled.div`
  cursor: pointer;
  display: flex;
`

const Wrapper = styled.div`
  height: calc(100% - 64px);
  display: flex;
`

const ActivitiesWrapper = styled('div')`
  height: 100%;

  > div {
    height: 100%;
    min-height: unset;
  }

  ${ActivitiesScrollbar} {
    height: calc(100% - 160px);
  }
`

const Header = styled(HeaderOrigin)`
  height: auto;
  display: flex;
  white-space: nowrap;
  gap: 16px;
  align-items: center;
  
  span {
    overflow: unset !important;
  }
`

export { ReviewDate, UpdateIndicator, RightSidebar, EntityDescription, IconWrapper, Wrapper, ActivitiesWrapper, Header }
